/**
 * External dependencies
 */
import { FC } from 'react';
import classNames from 'classnames/bind';

/**
 * Internal dependencies
 */
import classes from './Success.module.scss';
import { Paragraph } from '@/components';
import { ParagraphProps } from 'antd/es/typography/Paragraph';

const cx = classNames.bind(classes);

type SuccessProps = ParagraphProps;

const Success: FC<SuccessProps> = ({ children, className, ...props }) =>
	children ? (
		<Paragraph className={cx('success', className)} {...props}>
			{children}
		</Paragraph>
	) : null;

export default Success;
